import { useState, useEffect } from "react";
import { withSnackbar } from "notistack";
import { Helmet } from "react-helmet";
import SearchFilter from "../../components/common/SearchFilter";
import ProcedureList from "../../components/features/lists/procedures";
import ProcedureForm from "../../components/features/forms/procedure";
import { AddFab } from "../../components/common/FabButtuns";
import Loader from "../../components/common/Loader";
import {
  createProcedure,
  deleteProcedure,
  updateProcedure,
} from "../../api/api";
import { useDataLists } from "../../store/DataListsContextProvider";
import { v4 as uuidv4 } from "uuid";
import { setDataList } from "../../store/action-reducers";

const INIT_PROCEDURE = {
  Id: "",
  Name: "",
  Prefix: "",
  Description: "",
  Procedures:[],
};

const Procedure = (props) => {
  const [loading, setLoading] = useState(false);
  const [openProcedureForm, setOpenProcedureForm] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const { lists, dataListDispatch } = useDataLists();
  const [procedures, setProcedures] = useState({
    filtered: lists.procedures,
  });
  const [contextProcedure, setContextProcedure] = useState({
    current: {
      ...INIT_PROCEDURE,
      Id: uuidv4(),
    },
    changeType: "ADDITION",
  });


  useEffect(() => {
    if (filterValue) {
      setProcedures({
        filtered: getFilteredProcedures(filterValue, lists.procedures).sort(
          (a, b) => a.Prefix.charCodeAt(0) > b.Prefix.charCodeAt(0)
        ),
      });
    } else {
      setProcedures({
        filtered: lists.procedures,
      });
    }
  }, [filterValue]);

  const handleSaveProcedure = async (examinations) => {
    const ProcedureValues = Object.values(contextProcedure.current);

    if (ProcedureValues.includes("")) {
      props.enqueueSnackbar("ERROR : Please fill in all fields.", {
        preventDuplicate: true,
        variant: "warning",
      });
      return;
    }
    console.log("examinations",examinations);
    setLoading(true);

    if (contextProcedure.changeType === "ADDITION") {
      let Updatedprocedure = contextProcedure.current
       Updatedprocedure.Procedures = examinations
      const [, err] = await createProcedure(Updatedprocedure);
      if (!err) {
        let newProceduresList = [
          ...lists.procedures,
          contextProcedure.current,
        ].sort((a, b) => a.Prefix.charCodeAt(0) - b.Prefix.charCodeAt(0));

        setProcedures({filtered: newProceduresList})
        dataListDispatch(setDataList(newProceduresList, "procedures"))

        props.enqueueSnackbar("SUCCESS : Procedure created.", {
          preventDuplicate: true,
          variant: "success",
        });
      } else {
        console.error("ERROR : ", err);
        props.enqueueSnackbar(`ERROR : ${err.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
      }
    } else {
     let Updatedprocedure = contextProcedure.current
     Updatedprocedure.Procedures = examinations
      console.log("Updatedproceduret",Updatedprocedure);
      const [res, err] = await updateProcedure(Updatedprocedure);
      console.log("err",err);
      if (res) {
        let newProceduresList = [
          ...lists.procedures.filter(
            (procedure) => procedure.Id !== contextProcedure.current.Id
          ),
          contextProcedure.current,
        ];
        newProceduresList = newProceduresList.sort(
          (a, b) => a.Prefix.charCodeAt(0) - b.Prefix.charCodeAt(0)
        );

        setProcedures({filtered: newProceduresList})
        dataListDispatch(setDataList(newProceduresList, "procedures"))

        props.enqueueSnackbar("SUCCESS : Procedure updated.", {
          preventDuplicate: true,
          variant: "success",
        });
      } else {
        console.error(err);
        props.enqueueSnackbar(`ERROR : ${err.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
      }
    }

    setLoading(false);
    handleCloseProcedureForm();
  };

  const handleDeleteProcedure = async () => {
    setLoading(true);
    const [_, err] = await deleteProcedure(contextProcedure.current.Id);
    if (!err) {
      let newProceduresList = lists.procedures.filter(
        (procedure) => procedure.Id !== contextProcedure.current.Id
      );
      newProceduresList = newProceduresList.sort(
        (a, b) => a.Prefix.charCodeAt(0) - b.Prefix.charCodeAt(0)
      );

      setProcedures({filtered: newProceduresList})
      dataListDispatch(setDataList(newProceduresList, "procedures"))

      props.enqueueSnackbar("SUCCESS : Procedure deleted.", {
        preventDuplicate: true,
        variant: "success",
      });
      setLoading(false);
    } else {
      console.error(err);
      props.enqueueSnackbar(`ERROR : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
      setLoading(false);
    }
  };

  const handleOpenProcedureForm = (procedure) => {
    if (procedure.Prefix) {
      setContextProcedure({
        current: procedure,
        changeType: "EDIT",
      });
    } else {
      setContextProcedure({
        current: {
          ...INIT_PROCEDURE,
          Id: uuidv4(),
        },
        changeType: "ADDITION",
      });
    }
    setOpenProcedureForm(true);
  };

  const handleSetContextProcedure = (procedure) => {
    setContextProcedure({
      current: procedure,
      changeType: "EDIT",
    });
  };

  const handleProcedureDataChange = (e) => {
    setContextProcedure({
      ...contextProcedure,
      current: {
        ...contextProcedure.current,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleCloseProcedureForm = () => {
    setContextProcedure({
      current: {
        ...INIT_PROCEDURE,
        Id: uuidv4(),
      },
      changeType: "ADDITION",
    });
    setOpenProcedureForm(false);
  };

  const handleFilterValueChange = (e) => {
    e.preventDefault();
    setFilterValue(e.target.value);
  };

  const getFilteredProcedures = (filterString, procedures) => {
    const str = filterString.toLowerCase();
    if (!str) return procedures;
    else {
      return procedures.filter(
        (procedure) =>
          procedure.Name.toLowerCase().includes(str) ||
          procedure.Prefix.toLowerCase().includes(str)
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>Procedures</title>
      </Helmet>

      <SearchFilter
        handleChange={handleFilterValueChange}
        val={filterValue}
        placeholder={"Search Procedures(s) using Procedure 'Name' or 'prefix'"}
      />

      {loading ? (
        <Loader />
      ) : (
        <ProcedureList
          procedures={procedures.filtered}
          handleChange={handleProcedureDataChange}
          handleSetContextProcedure={handleSetContextProcedure}
          handleOpenProcedureForm={handleOpenProcedureForm}
          save={handleSaveProcedure}
          handleDelete={handleDeleteProcedure}
        />
      )}

      {openProcedureForm && (
        <ProcedureForm
          procedure={contextProcedure.current}
          edit={contextProcedure.changeType === "EDIT"}
          close={handleCloseProcedureForm}
          save={handleSaveProcedure}
          handleChange={handleProcedureDataChange}
          loading={loading}
        />
      )}

      <AddFab open={handleOpenProcedureForm} />
    </>
  );
};

export default withSnackbar(Procedure);
